export enum OutclinicDashboardLabel {
    late = 'late',
    planned = 'planned',
    toBePlanned = 'toBePlanned',
    toDo = 'toDo',
}
